import { appendReduxPart } from "infrastructure/store";

import UserProvider from "./UserProvider";
import { userSaga } from "./UserProvider.saga";
import { user } from "./UserProvider.slice";

export * from "./UserProvider.actions";
export * from "./UserProvider.state";
export * from "./UserContext";

export * from "./AuthorizedContent";
export * from "./Authorization.helpers";

export { UserProvider };

appendReduxPart(
  {
    reducerName: user.name,
    reducer: user.reducer
  },
  userSaga()
);
